'use client';

import { ErrorBoundaryFallback } from '@/components/errors/ErrorBoundaryFallback';
import { Providers } from '@/components/providers';

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <Providers>
      <ErrorBoundaryFallback error={error} onReset={reset} />
    </Providers>
  );
}
